/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 7897:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5671);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2963);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1120);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7112);
/* harmony import */ var _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4889);
/* harmony import */ var _utils_pricing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9299);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var ConfiguratorExtra = /*#__PURE__*/function (_HTMLElement) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ConfiguratorExtra, _HTMLElement);

  var _super = _createSuper(ConfiguratorExtra);

  function ConfiguratorExtra() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ConfiguratorExtra);

    _this = _super.call(this);

    var checkboxes = _this.querySelectorAll('.checkbox');

    var localCheckbox = _this.querySelector('.checkbox');

    var nextButton = _this.querySelector('.button-holder__button');

    var buttonRow = document.querySelector('.button-row__fade');
    var extrasBaseProduct = JSON.parse(_this.querySelector('.js-extra-base').innerHTML);
    var productData = JSON.parse(_this.querySelector('.js-product-data').innerHTML);
    var a2cButton = document.querySelector('.js-a2c');

    var colorGrids = _this.querySelectorAll('.color-grid');

    var continueToExtra = _this.querySelector('.js-continue');

    var continueToSummary = _this.querySelector('.js-false');

    var choicePanel = _this.querySelector('.configurator-extra-overlay');

    var extraTitle = document.querySelector('.extra__title');

    var pricingElement = _this.querySelector('.js-pricing');

    var previousButton = _this.querySelector('.button-holder__button--previous');

    var currentLayer = nextButton.dataset.current;
    var nextLayer = nextButton.dataset.next;
    var nextStep = document.querySelector(".layer-".concat(nextLayer));
    var currentStep = document.querySelector(".layer-".concat(currentLayer));
    var checkmark = document.querySelector(".layer-label-".concat(nextLayer - 1, " .icon-checkmark"));
    var currentOption = document.querySelector('.button-row__button input[checked]');
    var discountbase = document.querySelector('configurator-overview').dataset.baseDiscount;
    var discountextra = document.querySelector('configurator-overview').dataset.extraDiscount;
    var discount = currentOption.dataset.layer <= 3 ? discountbase : discountextra;

    var select = _this.querySelector('select');

    var param = select.getAttribute('data-select');
    console.log('extra');

    var setUrlParams = function setUrlParams(selectElement, variant, product, productId) {
      var id = product ? product.id : productId;
      var param = selectElement.getAttribute('data-select');
      var url = new URL(window.location.href);
      url.searchParams.set(param, "".concat(id, "-").concat(variant.id));
      window.history.replaceState({}, '', url);
    };

    var handleNextLayer = function handleNextLayer() {
      var newScrollPosition = currentStep.nextElementSibling.offsetWidth + buttonRow.scrollLeft;

      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.add('active');
        currentStep.nextElementSibling.classList.add('handled');
        nextStep.parentElement.classList.remove('button-row__button--no-events');
        buttonRow.scroll({
          top: 0,
          left: newScrollPosition,
          behavior: 'smooth'
        });
        if (nextStep.closest('.button-row__button.hidden') != null){
          document.querySelector('.layer-5').checked = true;
          document.querySelector('.layer-5').classList.add('active');
          document.querySelector(".layer-label-".concat(5, " .icon-checkmark")).classList.toggle('icon-checkmark--active');
        }
      } else {
        var overviewStep = document.querySelector('.layer-4');
        extraTitle.style.display = 'block';
        overviewStep.checked = true;
        overviewStep.classList.toggle('active');
          
        
        var selectedItems = JSON.parse(sessionStorage.getItem('configuratorConfig'));
        var filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];

        var selected_items = [];

        filteredItems.forEach(function(val){
          

        console.log(Object.entries(val)[0][1]);

          if (Object.entries(val)[0][1].extraProduct === true) {
            for (let i in val) {
              var v = val[i];
              if (v && v.product_title && v.option1 && v.option2) {
                selected_items.push({
                  title: v.product_title,
                  select_colour: v.full_option1,
                  select_size: v.full_option2
                });
              }
            }
          } else {
            selected_items.push({
              title: val.product_title,
              select_colour: val.full_option1,
              select_size: val.full_option2
            });
          }
        });

        window.dataLayer = window.dataLayer || [];

        // Check if exact same ecommerce.items already pushed
        const alreadyPushed = window.dataLayer.some(entry =>
          entry.event === 'configuratorItemsSelected' &&
          JSON.stringify(entry.ecommerce?.items) === JSON.stringify(selected_items)
        );

        if (!alreadyPushed) {
          window.dataLayer.push({
            event: 'configuratorItemsSelected',
            ecommerce: {
              items: selected_items
            }
          });
        }

      }
        var buttons = document.querySelectorAll('.button-row__button.hidden');
           buttons.forEach(function (button) {
          if (button.querySelector('.icon-checkmark--active') != null){
            document.querySelector('.layer-5').checked = true;
            document.querySelector('.layer-5').classList.add('active');
            document.querySelector(".layer-label-".concat(5, " .icon-checkmark")).classList.toggle('icon-checkmark--active');
          }
        });
        console.log(overviewStep);
        setTimeout(function(){

        document.querySelector(".layer-label-4").click();
       document.querySelector('.configurator-variant').classList.add("hidden");
       document.querySelector('.configurator-variant[data-layer="4"]').classList.remove("hidden");
       
        },1000);
    };

    var handleBaseProductVariant = function handleBaseProductVariant(config) {
      var buildTitle = '';

      if (config[4] && config[4][1]) {
        buildTitle += "BP".concat(config[4][1].option2.toLowerCase());
      }

      if (config[4] && config[4][2]) {
        buildTitle += "BK".concat(config[4][2].option2.toLowerCase());
      }

      if (config[4] && config[4][3]) {
        buildTitle += "K".concat(config[4][3].option2.toLowerCase());
      }

      var variant = extrasBaseProduct.variants.find(function (variant) {
        return variant.title === buildTitle;
      });
      a2cButton.dataset.extra = variant ? variant.id : null;
    };

    var handleVariantChange = function handleVariantChange(value, selector, item, remove) {
      if (value.includes('bedMATE') || value.includes('bigDOT')) {
        var valueMinusPrice = value.split(' - ')[1];
        var productTitle = value.split(' - ')[0];

        var _productData = JSON.parse(_this.querySelector(".js-product-".concat(selector)).innerHTML); // const layer = this.querySelector('.configurator-variant') ? this.querySelector('.configurator-variant').dataset.layer : null

        var layer = _this.querySelector(".product-".concat(selector)) ? _this.querySelector(".product-".concat(selector)).dataset.layer : null;

        var selectedItem = _productData.map(function (product) {
          return product.variants.find(function (variant) {
            return variant.product_title.includes(productTitle) && variant.title.includes(valueMinusPrice);
          });
        });

        var variant;
        selectedItem.forEach(function (item) {
          if (item !== undefined) {
            variant = item;
          }
        });
        setUrlParams(select, variant, _productData.filter(function (item) {
          return item.variants.includes(variant);
        })[0], variant.product_id);
        var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];

        if (currentConfig['4']) {
          currentConfig['4'][item] = variant;
        } else {
          currentConfig['4'] = {};
          currentConfig['4'][item] = variant;
        }

        sessionStorage.setItem('configuratorConfig', JSON.stringify(currentConfig));
        handleBaseProductVariant(currentConfig);
        (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .renderPrice */ .Bw)((0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleDiscountSelection */ .Br)(currentConfig), currentConfig);

        if (variant && pricingElement) {
              const isMultiple = (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.oX)(variant);

              const discountedPrice = (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(
                (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.PM)(
                  variant.price,
                  Number(discountextra),
                  isMultiple
                )
              );

              const originalPrice = isMultiple
                ? (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(variant.price * 2)
                : (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(variant.price);

              pricingElement.innerHTML = `${discountedPrice}<span class="percentage">(20%)</span><s>${originalPrice}</s> `;
            }

        if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          var extraProducts = currentConfig[4];
          var totalPrice = 0;
          Object.values(extraProducts).forEach(function(item) {
            if (item && item.product_id) {
              var price = item.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          var discounted = totalPrice - (totalPrice * 0.2);
          var formattedDiscounted = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(discounted);
          var formattedOriginal = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(totalPrice);
          document.querySelectorAll('.js_price_extra')[document.querySelectorAll('.js_price_extra').length - 1].innerHTML =
            formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }


        if (layer && remove === false) {
          (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleProductImage */ .Au)(variant.image, layer, variant.image_url);
        }

        if (remove && layer) {
          (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleRemoveProductImage */ .M7)(layer);
        }
      } else {
        var _valueMinusPrice = value.split(' - ')[0];

        var _productData2 = JSON.parse(_this.querySelector(".js-product-".concat(selector)).innerHTML); // const layer = this.querySelector('.configurator-variant') ? this.querySelector('.configurator-variant').dataset.layer : null


        var _layer = _this.querySelector(".product-".concat(selector)) ? _this.querySelector(".product-".concat(selector)).dataset.layer : null;

        var _variant = _productData2.variants !== undefined ? _productData2.variants.find(function (variant) {
          return variant.title.includes(_valueMinusPrice);
        }) : _productData2.find(function (variant) {
          return variant.title.includes(_valueMinusPrice);
        });

        var _currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];

        if (_currentConfig['4']) {
          _currentConfig['4'][item] = _variant;
        } else {
          _currentConfig['4'] = {};
          _currentConfig['4'][item] = _variant;
        }

        sessionStorage.setItem('configuratorConfig', JSON.stringify(_currentConfig));
        handleBaseProductVariant(_currentConfig);
        (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .renderPrice */ .Bw)((0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleDiscountSelection */ .Br)(_currentConfig), _currentConfig);

       if (_variant && pricingElement) {
         const isMultiple = (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.oX)(_variant);
          const originalPrice = isMultiple
            ? (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(_variant.price * 2)
            : (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(_variant.price);

          const discountedPrice = (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(
            (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.PM)(_variant.price, 25, isMultiple)
          );

          pricingElement.innerHTML = `${discountedPrice}<span class="percentage">(20%)</span> <s>${originalPrice}</s>`;
        }


        if (_layer && remove === false) {
          (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleProductImage */ .Au)((_variant === null || _variant === void 0 ? void 0 : _variant.image) !== undefined ? _variant.image : _variant.images, _layer, _variant.image_url);
        }

        if (remove && _layer) {
          (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleRemoveProductImage */ .M7)(_layer);
        }
      }

        var variantSelector = _this.querySelector(".variant-selector__select--".concat(selector));

        console.log(variantSelector, " variantSelector ", variantSelector.value);

        var isLast = variantSelector.closest('configurator-extra') === document.querySelectorAll('configurator-extra')[document.querySelectorAll('configurator-extra').length - 1];
      if(variantSelector.querySelector(`option[value="${variantSelector.value}"]`).hasAttribute("disabled") == true) {
        variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("disabled");
        if (isLast) {
          variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("for_the_last");
        }
      } else {
        variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("disabled");
        
        if (isLast) {
          variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("for_the_last");
        }
      }
    };

    var handlePillowColor = function handlePillowColor(product, value, selector, item) {
      var variant = product.variants.find(function (variant) {
        return variant.title.includes(value);
      });

      if (variant == undefined || variant == null) {
        variant = product.variants.find(function (variant) {
          return variant.title.includes(value.split('-')[1].trim());
        });
      }

      var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];

      if (currentConfig['4']) {
        currentConfig['4'][item] = variant;
      } else {
        currentConfig['4'] = {};
        currentConfig['4'][item] = variant;
      }

      const isMultiple = (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.oX)(variant);

const originalPrice = isMultiple
  ? (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(variant.price * 2)
  : (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(variant.price);

const discountedPrice = (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(
  (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.PM)(
    variant.price,
    Number(discountextra),
    isMultiple
  )
);

pricingElement.innerHTML = 
  `${discountedPrice} <span class="percentage">(${discountextra}%)</span><s>${originalPrice}</s> `;

      sessionStorage.setItem('configuratorConfig', JSON.stringify(currentConfig));
      handleBaseProductVariant(currentConfig);
    };

    var handleProductSelect = function handleProductSelect(product, select, checkbox, elementSelector) {
      console.log(elementSelector, " elementSelector", select);
      var variants = product.variants;
      var allowedOptions = ['50X160', '50X180', '60X70', '50X10', '65X65', '50X75', '40X80', '80X80'];
      var layer = _this.querySelector(".product-".concat(elementSelector)) ? _this.querySelector(".product-".concat(elementSelector)).dataset.layer : null;
      var bedMateSize = sessionStorage.getItem('bedMateSize') ? sessionStorage.getItem('bedMateSize') : null;
      var prefSize = sessionStorage.getItem('studiosuite_pref_size') ? JSON.parse(sessionStorage.getItem('studiosuite_pref_size')) : null;
      var items = 0;
      if(select.dataset.select == 'extra-bedmate' ||  select.dataset.select == 'extra-bigdot') {
        var jsonScript = select.closest('configurator-extra').querySelector('.js-product-data');
  if (jsonScript) {
    const data = JSON.parse(jsonScript.textContent);
const allVariants = data.flatMap(product => product.variants);
var disabled = true;

  var options = allVariants.map(function (variant) {
    items++;
    return `<option data-size="${variant.option2.split('X').pop()}" ${variant.available ? '' : 'disabled'} value="${variant.product_title} - ${variant.option2}">${variant.product_title} - ${variant.option2}</option>`;
  });

  }
      } else {
      var options = variants.map(function (variant) {
        if (allowedOptions.includes(variant.option2.toUpperCase())) {
          if (variant.available) {
            disabled = false;
          }
          items++;
          // return "<option \n          value=\"".concat(variant.option2, "\" \n          data-old-price=\"").concat((0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */ .D)(variant.price), "\" \n          data-id=\"").concat(variant.id, "\" \n          ").concat(!variant.available ? 'disabled' : null, " \n          ").concat(variant.option2.includes('90X200X30') && variant.inventory_quantity <= 1 ? 'disabled' : null, " \n          ").concat(variant.option2.includes('140') && variant.inventory_quantity <= 1 ? 'disabled' : null, " \n          ").concat(variant.option2.includes('60X70') && variant.inventory_quantity <= 1 ? 'disabled' : null, "\n          ").concat(variant.option2.includes(prefSize) ? 'selected' : null, "\n          ").concat(variant.option2.includes(bedMateSize) ? 'selected' : null, ">\n           ").concat(variant.option2.includes('80X80') || variant.option2.includes('40X80') || variant.option2.includes('90X200X30') || variant.option2.includes('50X80') || (variant.option2 == '50X160test' && product.product_type == 'bedMATE case') || variant.option2.includes('140X200') || variant.option2.includes('140X220') || variant.option2.includes('260X220') || variant.option2.includes('240X220') || variant.option2.includes('200X220') || variant.option2.includes('200X200') || variant.option2.includes('60X70') || variant.option2.includes('65X65') || variant.option2.includes('50X75') || variant.option2.includes('135') || (variant.option2.includes('155')  ? variant.option2 + ' ' +window.pieces_text  : variant.option2, "\n          </option>");
          return "<option \n          value=\""
  .concat(variant.option2, "\" \n          data-old-price=\"")
  .concat((0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__ /* .pricing */ .D)(variant.price), "\" \n          data-id=\"")
  .concat(variant.id, "\" \n          ")
  .concat(!variant.available ? 'disabled' : '', " \n          ")
  .concat(variant.option2.includes('80X80') && variant.inventory_quantity <= 1 ? 'disabled' : '', " \n          ")
  .concat(variant.option2.includes('40X80') && variant.inventory_quantity <= 1 ? 'disabled' : '', " \n          ")
  .concat(variant.option2.includes('90X200X30') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('50X80') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat((variant.option2 == '50X160test' && product.product_type == 'bedMATE case') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('140X200') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('140X220') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('60X70') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('60X65') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('50X75') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('135') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes('155') && variant.inventory_quantity <= 1 ? 'disabled' : '', "\n          ")
  .concat(variant.option2.includes(prefSize) ? 'selected' : '', "\n          ")
  .concat(variant.option2.includes(bedMateSize) ? 'selected' : '', ">\n           ")
  .concat(
    variant.option2.includes('80X80') ||
    variant.option2.includes('40X80') ||
    variant.option2.includes('90X200X30') ||
    variant.option2.includes('50X80') ||
    (variant.option2 == '50X160test' && product.product_type == 'bedMATE case') ||
    variant.option2.includes('140X200') ||
    variant.option2.includes('140X220') ||
    variant.option2.includes('60X70') ||
    variant.option2.includes('65X65') ||
    variant.option2.includes('50X75') ||
    variant.option2.includes('135') || 
    variant.option2.includes('155')
      ? variant.option2 + ' ' + window.pieces_text
        : variant.option2,
    "\n          </option>"
  );

        }
      });
     }

      if (items === 1) {
        select.style.backgroundImage = 'none';
      }

      var selectedVariant = variants.find(function (variant) {
        return variant.option2.includes(prefSize);
      }) !== undefined ? variants.find(function (variant) {
        return variant.option2.includes(prefSize);
      }) : variants.find(function (variant) {
        return variant.option2.includes(bedMateSize);
      });
      var BaseOrSelectedVariant = selectedVariant !== undefined ? selectedVariant : variants[0];

      console.log(BaseOrSelectedVariant);

      setUrlParams(select, BaseOrSelectedVariant, product);

      if (BaseOrSelectedVariant && pricingElement) {
  const isMultiple = (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.oX)(BaseOrSelectedVariant);

  const originalPrice = isMultiple
    ? (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(BaseOrSelectedVariant.price * 2)
    : (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(BaseOrSelectedVariant.price);

  const discountedPrice = (0, _utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(
    (0, _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__.PM)(
      BaseOrSelectedVariant.price,
      Number(discountextra),
      isMultiple
    )
  );

  pricingElement.innerHTML = 
    `${discountedPrice} <span class="percentage">(${discountextra}%)</span><s>${originalPrice}</s> `;
}


      select.innerHTML = options.join('');
      var correctLayer = layer;

      if (product.variants[0].product_title.includes('Kussensloop')) {
        correctLayer = 5;
      } else {
        correctLayer = layer;
      }

      if (product.variants[0].product_title.includes('bigDOT')) {
        correctLayer = 7;
      } else {
        correctLayer = layer;
      }

      if(select.dataset.select == 'extra-bedmate' ||  select.dataset.select == 'extra-bigdot') {
        if(BaseOrSelectedVariant) {
          var option_title = BaseOrSelectedVariant.product_title + ' - '+ BaseOrSelectedVariant.option2;
          var matchingOption = Array.from(select.options).find(function(option) {
      return option.textContent.trim() === option_title.trim();
    });

    if (matchingOption) {
      matchingOption.selected = true;
      // select.dispatchEvent(new Event('change')); 
    }
        }
      }

      if (bedMateSize !== null) {
        var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];

        if (currentConfig['4']) {
          currentConfig['4'][checkbox.dataset.extraItem] = BaseOrSelectedVariant;
        } else {
          currentConfig['4'] = {};
          currentConfig['4'][checkbox.dataset.extraItem] = BaseOrSelectedVariant;
        }

        sessionStorage.setItem('configuratorConfig', JSON.stringify(currentConfig));
      } else {
        // select first available option
        var firstAvailableVariant = variants.find(function (variant) {
          return variant.available;
        });
        console.log("firstAvailableVariant ", firstAvailableVariant, variants[0]);
        handlePillowColor(product, firstAvailableVariant ? firstAvailableVariant.option2: variants[0].option2, checkbox.dataset.selector, checkbox.dataset.extraItem);
        if(firstAvailableVariant == undefined ) {
          select.querySelector('option:first-of-type').selected = true;
           select.dispatchEvent(new Event('change')); 
        }
      }
      
      if (select.value == '' || select.value == null){
        select.querySelector('option:first-of-type').selected = true;
      }
        var isLast = select.closest('configurator-extra') === document.querySelectorAll('configurator-extra')[document.querySelectorAll('configurator-extra').length - 1];
         if(select.querySelector(`option[value="${select.value}"]`).hasAttribute("disabled") == true) {
        select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("disabled");
        if (isLast) {
          select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("for_the_last");
        }
      } else {
        select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("disabled");
        if (isLast) {
          select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("for_the_last");
        }
      }
      
        window.updateSummaryPopup();

      (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleProductImage */ .Au)(product.variants[0].image, correctLayer, product.variants[0].image_url);
      select.addEventListener('change', function () {
        handlePillowColor(product, select.value, checkbox.dataset.selector, checkbox.dataset.extraItem);
        setUrlParams(select, BaseOrSelectedVariant, product);

        if (select.value.includes('50')) {
          sessionStorage.setItem('bedMateSize', select.value);
        }

        
        var isLast = select.closest('configurator-extra') === document.querySelectorAll('configurator-extra')[document.querySelectorAll('configurator-extra').length - 1];
      if(select.querySelector(`option[value="${select.value}"]`).hasAttribute("disabled") == true) {
        select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("disabled");
        if (isLast) {
          select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("for_the_last");
        }
      } else {
        select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("disabled");
        if (isLast) {
          select.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("for_the_last");
        }
      }
      
        window.updateSummaryPopup();

      });
    };

    var handleActiveColor = function handleActiveColor(colorDot, colorDots) {
      colorDots.forEach(function (dot) {
        dot.querySelector('.color').classList.remove('current-selected');
      });
      colorDot.querySelector('.color').classList.add('current-selected');
    };

    var handleColorIndicator = function handleColorIndicator(button) {
      var colorIndicator = _this.querySelector(button.dataset.colortarget);

      var color = button.dataset.color;

      if (color && colorIndicator) {
        colorIndicator.innerHTML = color;
      }
    };

    var handleFallbackImage = function handleFallbackImage() {
      var config = JSON.parse(sessionStorage.getItem('configuratorConfig'));

      if (config && config[1] === null) {
        var fallbackImage = document.querySelector('.configurator-media__inner').dataset.fallbackImage;
        var baseImageLayer = document.querySelector('.image-layer-1');
        baseImageLayer.removeAttribute('srcset');
        baseImageLayer.src = fallbackImage;
      }
    };

    var handleColorDots = function handleColorDots(checkbox, variantSelector) {
      var colorDots = _this.querySelectorAll('.colors-grid__item');

      var handleFallbackColor = function handleFallbackColor() {
        colorDots.forEach(function (button) {
          if (button.querySelector('.color').classList.contains('current-selected')) {
            handleColorIndicator(button);
          }
        });
      };

      if (colorDots) {
        colorDots.forEach(function (colorDot) {
          colorDot.addEventListener('click', function () {
            handleActiveColor(colorDot, colorDots);

            var productData = _this.querySelector(".js-product-".concat(checkbox.dataset.selector)).innerHTML;

            var product = JSON.parse(productData).find(function (p) {
              return p.id === Number(colorDot.dataset.id);
            });

            if (product) {
              handleProductSelect(product, variantSelector, checkbox, checkbox.dataset.selector);
            }

            handleColorIndicator(colorDot);
            handleFallbackImage(); // initial bedmate size

            var bedMateSize = sessionStorage.getItem('bedMateSize') ? sessionStorage.getItem('bedMateSize') : null;

            if (bedMateSize !== null) {
              var firstOption = variantSelector.querySelectorAll('option:not([disabled])')[0];
              var prefOption = variantSelector.querySelector("option[value=\"".concat(bedMateSize, "\"]"));

              if (prefOption !== null) {
                variantSelector.value = bedMateSize;
                handleProductSelect(product, variantSelector, checkbox, checkbox.dataset.selector);
              }
            }

            var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];
           if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          var extraProducts = currentConfig[4];
          var totalPrice = 0;
          Object.values(extraProducts).forEach(function(item) {
            if (item && item.product_id) {
              var price = item.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          var discounted = totalPrice - (totalPrice * 0.2);
          var formattedDiscounted = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(discounted);
          var formattedOriginal = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(totalPrice);
          document.querySelectorAll('.js_price_extra')[document.querySelectorAll('.js_price_extra').length - 1].innerHTML =
            formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }

        var isLast = variantSelector.closest('configurator-extra') === document.querySelectorAll('configurator-extra')[document.querySelectorAll('configurator-extra').length - 1];
          if(variantSelector.querySelector(`option[value="${variantSelector.value}"]`).hasAttribute("disabled") == true) {
        variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("disabled");
        if (isLast) {
          variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.add("for_the_last");
        }

      } else {
        variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("disabled");
        if (isLast) {
          variantSelector.closest('configurator-extra').querySelector('button.button-holder__button.button').classList.remove("for_the_last");
        }
      }
      

          });
          colorDot.addEventListener('mouseenter', function () {
            handleColorIndicator(colorDot);
          });
          colorDot.addEventListener('mouseleave', function () {
            handleFallbackColor();
          });
        });
      }
    };

    if (checkboxes) {
      checkboxes.forEach(function (checkbox) {
        var variantSelector = _this.querySelector(".variant-selector__select--".concat(checkbox.dataset.selector));

        handleColorDots(checkbox, variantSelector);
        checkbox.addEventListener('change', function (e) {
          var productContainer = _this.querySelector(".product-".concat(checkbox.dataset.selector));

          if (checkbox.checked && productContainer) {
            productContainer.classList.remove('hidden');
            checkmark.classList.toggle('icon-checkmark--active');
          } else {
            var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];
            checkmark.classList.toggle('icon-checkmark--active');

            if (currentConfig['4']) {
              currentConfig['4'][checkbox.dataset.extraItem] = null;
              sessionStorage.setItem('configuratorConfig', JSON.stringify(currentConfig));
              (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleRemoveProductImage */ .M7)(checkbox.dataset.extralayer);
            }

            productContainer.classList.add('hidden');
          }

          console.log(Number(checkbox.dataset.extraItem), checkbox.dataset.selector,  " Number(checkbox.dataset.extraItem)");
          var buttons = document.querySelectorAll('.button-row__button.hidden');
           buttons.forEach(function (button) {
          if (button.querySelector('.icon-checkmark--active') != null){
            document.querySelector('.layer-5').checked = true;
            document.querySelector('.layer-5').classList.add('active');
            document.querySelector(".layer-label-".concat(5, " .icon-checkmark")).classList.toggle('icon-checkmark--active');
          }
        });

          if (Number(checkbox.dataset.extraItem) !== 1 && Number(checkbox.dataset.extraItem) !== 4) {
            handleColorDots(checkbox, variantSelector);
          } else {
            if (variantSelector && checkbox.checked) {
              //initial value select

              console.log("ssss sss s s ");

              var firstOption = variantSelector.querySelectorAll('option:not([disabled])')[0];
              var prefSize = sessionStorage.getItem('studiosuite_pref_size') ? sessionStorage.getItem('studiosuite_pref_size') : null;
              var prefOption = variantSelector.querySelector("option[data-size=".concat(prefSize, "]"));
              if (prefOption !== null) prefOption.selected = true;
              handleVariantChange(
                prefOption !== null ? prefOption === null || prefOption === void 0 ? void 0 : prefOption.value : firstOption === null || firstOption === void 0 ? void 0 : firstOption.value,
                checkbox.dataset.selector, checkbox.dataset.extraItem, false); // initial bedmate size

              var bedMateSize = sessionStorage.getItem('bedMateSize') ? sessionStorage.getItem('bedMateSize') : null;

              if (bedMateSize !== null) {
                var bedMateOption = variantSelector.querySelector("option[value=\"".concat(bedMateSize, "\"]"));

                if (bedMateOption) {
                  bedMateOption.selected = true;
                  handleVariantChange(bedMateOption.value, checkbox.dataset.selector, checkbox.dataset.extraItem, false);
                }
              }

              variantSelector.addEventListener('change', function (e) {
                sessionStorage.setItem('bedMateSize', e.target.value.split(' - ')[1]); // sessionStorage.setItem('studiosuite_pref_size', selectedSize)

                handleVariantChange(variantSelector.value, checkbox.dataset.selector, checkbox.dataset.extraItem, false);
              });
              handleFallbackImage();
            } else if (checkbox.checked) {
              var _productData3 = _this.querySelector(".js-product-".concat(checkbox.dataset.selector)).innerHTML;

              var product = JSON.parse(_productData3);
              handleVariantChange(product.variants[0].option2, checkbox.dataset.selector, checkbox.dataset.extraItem, false);
              handleFallbackImage();
            }
          }

            var buttons = document.querySelectorAll('.button-row__button.hidden');
           buttons.forEach(function (button) {
          if (button.querySelector('.icon-checkmark--active') != null){
            document.querySelector('.layer-5').checked = true;
            document.querySelector('.layer-5').classList.add('active');
            document.querySelector(".layer-label-".concat(5, " .icon-checkmark")).classList.toggle('icon-checkmark--active');
          }
        });

        var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];
           if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          var extraProducts = currentConfig[4];
          var totalPrice = 0;
          Object.values(extraProducts).forEach(function(item) {
            if (item && item.product_id) {
              var price = item.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          var discounted = totalPrice - (totalPrice * 0.2);
          var formattedDiscounted = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(discounted);
          var formattedOriginal = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(totalPrice);
          document.querySelectorAll('.js_price_extra')[document.querySelectorAll('.js_price_extra').length - 1].innerHTML =
            formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }
        
        });
      });
      nextButton.addEventListener('click', function () {
        handleNextLayer();
        
    if ($(window).width() <= 768) {
        console.log("mobile");
        window.scrollTo({
          top: 132,
          left: 0,
          behavior: "smooth",
        });
    } else {
       window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
    }

      });
      previousButton.addEventListener('click', function (e) {
        var nextLayer = previousButton.dataset.next;
        var currentLayer = previousButton.dataset.current;
        var nextStep = document.querySelector(".layer-".concat(nextLayer));
        var currentLabel = document.querySelector(".layer-label-".concat(currentLayer));
        var currentlabelwidth = document.querySelector(".layer-label-".concat(currentLayer)).offsetWidth;
        var checkmark = document.querySelector(".layer-label-".concat(currentLayer, " .icon-checkmark"));
        var overview = document.querySelector('configurator-overview');
        var newScrollPosition = currentlabelwidth + buttonRow.scrollRight;

        if (Number(nextLayer) == 4) {
          overview.classList.remove('hidden');
             
         var selectedItems = JSON.parse(sessionStorage.getItem('configuratorConfig'));
         var filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];
 
         var selected_items = [];

         filteredItems.forEach(function(val){
           if (Object.entries(val)[0][1].extraProduct === true) {
             for (let i in val) {
               var v = val[i];
               if (v && v.product_title && v.option1 && v.option2) {
                 selected_items.push({
                   title: v.product_title,
                   select_colour: v.full_option1,
                   select_size: v.full_option2
                 });
               }
             }
           } else {
             selected_items.push({
               title: val.product_title,
               select_colour: val.full_option1,
               select_size: val.full_option2
             });
           }
         });
 
         window.dataLayer = window.dataLayer || [];
 
         // Check if exact same ecommerce.items already pushed
         const alreadyPushed = window.dataLayer.some(entry =>
           entry.event === 'configuratorItemsSelected' &&
           JSON.stringify(entry.ecommerce?.items) === JSON.stringify(selected_items)
         );
 
         if (!alreadyPushed) {
           window.dataLayer.push({
             event: 'configuratorItemsSelected',
             ecommerce: {
               items: selected_items
             }
           });
         }
  
        }

        if (nextStep) {
          nextStep.checked = true;
          nextStep.classList.remove('active');
          nextStep.parentElement.classList.remove('button-row__button--no-events');
          checkmark.classList.remove('icon-checkmark--active');
          currentLabel.classList.remove('handled');
          buttonRow.scroll({
            top: 0,
            left: newScrollPosition,
            behavior: 'smooth'
          });
        }
      });

      if (colorGrids) {
        colorGrids.forEach(function (colorGrid) {
          (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleColorScroll */ .au)(colorGrid);
        });
      }

      var handleActiveURLParams = function handleActiveURLParams() {
        var url = new URL(window.location.href);
        url.searchParams.forEach(function (value, key) {
          if (param === key) {
            var productId = value.split('-')[0];
            var variantId = value.split('-')[1];
            var product = productData.find(function (p) {
              return p.id === Number(productId);
            });
            console.log(product);
            handleProductSelect(product, select, localCheckbox, localCheckbox.dataset.selector);
            localCheckbox.checked = true;
            var container = localCheckbox.closest('.configurator-variant');
            var colorDotContainer = container === null || container === void 0 ? void 0 : container.querySelector('.product-option');
            colorDotContainer === null || colorDotContainer === void 0 ? void 0 : colorDotContainer.classList.remove('hidden');

            var activeProduct = _this.querySelector(".colors-grid__item[data-id=\"".concat(productId, "\"]"));

            var color = activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.querySelector('.color');
            color === null || color === void 0 ? void 0 : color.classList.add('current-selected');
          }
        });
      }; // onload url params


      setTimeout(function () {
        handleActiveURLParams();
      }, 100);
    }

    return _this;
  }

  return ConfiguratorExtra;
}( /*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(HTMLElement));

if (customElements.get('configurator-extra') === undefined) {
  customElements.define('configurator-extra', ConfiguratorExtra);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 6960;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			6960: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(7897); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;